



















import {Component, Vue} from 'vue-property-decorator'
import {Form as ElForm} from 'element-ui/types/element-ui'

@Component
export default class Login extends Vue {
  formData = {
    username: '',
    password: ''
  };

  ruleValidate = {
    username: [{required: true, trigger: 'blur', message: ''}]
  };

  handleSubmit() {
    (this.$refs['login'] as ElForm).validate(valid => {
      if (valid) {
        const params = {
          username: this.formData.username,
          password: this.formData.password
        };
        this.axios.post('/signin', params).then(res => {
          sessionStorage.setItem('rtty-sid', res.data);
          this.$router.push('/');
        }).catch(() => {
          this.$message.error(this.$t('Signin Fail! username or password wrong.').toString());
        });
      }
    });
  }

  reset() {
    (this.$refs['login'] as ElForm).resetFields();
  }

  mounted() {
    this.ruleValidate['username'][0].message = this.$t('username is required').toString();
  }
}
